export enum SignMailStatus {
  STARTED = 'STARTED',
  GREETING = 'GREETING',
  COUNTDOWN = 'COUNTDOWN',
  RECORDING = 'RECORDING',
  INACTIVE = 'INACTIVE',
}
